import React from "react";

// Libraries
import { PropTypes } from "prop-types";
// Constants
const vehicleSwitchButtonStyle = { width: "100%", height: 40, fontWeight: "bold" }

const VehicleSwitchButton = (props) => {
    const { text, onClick } = props;
    return (
        <button
            style={vehicleSwitchButtonStyle}
            onClick={(e) => {
                e.preventDefault();
                onClick();
            }}
        >
            {text}
        </button>
    );
};

VehicleSwitchButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};

export default VehicleSwitchButton;



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonSwitchBetweenTables.js